export const STRUCTURE_NOTE_RESPONSE_FORMAT = {
  type: 'json_schema' as const,
  name: 'structured_note',
  strict: true,
  schema: {
    type: 'object',
    properties: {
      keyTakeaways: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            text: { type: 'string' },
          },
          required: ['text'],
          additionalProperties: false,
        },
      },
      agreementsDecisions: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            text: { type: 'string' },
          },
          required: ['text'],
          additionalProperties: false,
        },
      },
      nextSteps: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            task: { type: 'string' },
            responsible: { type: ['string', 'null'] },
            deadline: { type: ['string', 'null'] },
          },
          required: ['task', 'responsible', 'deadline'],
          additionalProperties: false,
        },
      },
    },
    required: ['keyTakeaways', 'agreementsDecisions', 'nextSteps'],
    additionalProperties: false,
  },
};
